/**
 * O número do passo no fluxo mensal, simples: "1.", "2.". Com `alinhar`, quem
 * não tem número ganha o mesmo espaço vazio, e os nomes do grupo ficam na
 * mesma coluna.
 */
export function NumeroDoPasso(props: {
  readonly numero: number | null;
  readonly alinhar?: boolean;
}): JSX.Element | null {
  if (props.numero === null && props.alinhar !== true) return null;
  return (
    <span
      aria-hidden={props.numero === null}
      className="w-6 shrink-0 font-medium tabular-nums text-conteudo-secundario sm:self-start sm:pt-px"
    >
      {props.numero === null ? '' : `${props.numero}.`}
    </span>
  );
}
